// Import required dependencies
import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Ensure carousel styles are imported
import { COUNTRY_CODE,SCREEN_SIZE } from '@src/config/constant';
import WarningaICN from '@src/styles/webroot/images/warning-icn.svg';
import { useNavigate } from "react-router-dom";

const isCountryId = COUNTRY_CODE ==='id' ? true : false;

interface ReactSliderProps {
  screenType: string;
}

// Shared styles for the carousel content

  

// Component for slide content with text
const SlideWithText = ({
  title,
  highlight,
  highlightwhite,
  description,
  image,
}: {
  title: string;
  highlight: string;
  highlightwhite:string;
  description: string;
  image: string;
}) => (
  <div className="registered-slider-outer">
    <div className="slider-txt-outer">
      <span className="slider-title">{title}</span>
      <div className="hightlight-txt">
        <span className="hightlight-main">{highlight}</span>
        <span>&nbsp;{highlightwhite}</span>
      </div>
      <span className="discreption-txt">{description}</span>
    </div>
    <div className="slider-img-outer">
    <img src={image} alt="slide"/>
    </div>
  </div>
);

// Component for slide content with only an image
const SlideWithImage = ({ image }: { image: string }) => (
  <div>
    <img src={image} alt="slide"/>
  </div>
);

// Functional Component for the React Slider
const ReactSlider = ({ screenType }: ReactSliderProps) => {
  const navigate = useNavigate();
  const [isMobileView, setIsMobileView] = useState<boolean>(() => {
      if (typeof window === "undefined") {
          return false;
      }
      return window.innerWidth < SCREEN_SIZE;
  });

  const isSignupMobile = isMobileView && window.location.pathname === "/signup/start";
  
  const registerSlides = [
    {
      title: "100% Timely",
      highlight: "Referral ",
      highlightwhite: "Fee Payout",
      description: "Receive payments on time without any delays",
      image: "/images/Layer_1.png",
    },
    {
      title: "No Paperwork",
      highlight: "100% ",
      highlightwhite: "Digital Process",
      description: "Fast, Hassle Free Digital Solution",
      image: "/images/Asset_1.png",
    },
    {
      title: "Dashboard to",
      highlight: "Track",
      highlightwhite: "Your Business",
      description: "Real time tracking",
      image: "/images/F_Layer_1.png",
    },
  ];

  const loginSlides = isCountryId
    ? [
        { image: "/images/image138.png" },
        { image: "/images/ClaimInsurance1.png" },
        { image: "/images/AddUser201.png" },
        { image: "/images/Group1000006483.png" },
      ]
    : [
        { image: "/images/Group_1000006483.png" },
        { image: "/images/Group2_1000006483.png" },
        { image: "/images/Group3_1000006483.png" },
      ];

  return (
    <div className="demo-carousel register-slider-outer">
      {
        isSignupMobile &&
        <div onClick={() => navigate("/login")} className="register-back-txt"><i className="ic-arrow_back"></i>Register</div>
      }
      <Carousel
        showArrows={false}
        autoPlay={false}
        interval={3000}
        showThumbs={false}
        infiniteLoop
        showStatus={false}
      >
        {screenType === "Register"
          ? registerSlides.map((slide, index) => (
              <SlideWithText
                key={index}
                title={slide.title}
                highlight={slide.highlight}
                highlightwhite={slide.highlightwhite}
                description={slide.description}
                image={slide.image}
              />
            ))
          : loginSlides.map((slide, index) => (
              <SlideWithImage key={index} image={slide.image} />
            ))}
      </Carousel>
      {
        isSignupMobile &&
        <div className="footer-btn-fixed">
          <button className="btn-primary" onClick={() => navigate("/register")}>
            Register With Us
          </button>
          <span>
            <img src={WarningaICN} />
            Your data is 100% safe and secure with us
          </span>
        </div>
      }
    </div>
  );
};

export default ReactSlider;
